import { render, staticRenderFns } from "./result-icon.vue?vue&type=template&id=a422ff32"
import script from "./result-icon.vue?vue&type=script&lang=js"
export * from "./result-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports